function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgCarrot = function SvgCarrot(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 297 297",
    style: {
      enableBackground: "new 0 0 297 297"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D5C295"
    },
    cx: 148.5,
    cy: 148.5,
    r: 148.5
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#897256"
    },
    d: "M293.966,118.495l-34.99-34.99c-11.177,4.548-22.458,11.429-34.476,7.995c-3-2-9-3-13-1 c-29,16-51,39-72,65c-3,2-4,7-6,10c-13,15-21,30-32,47c-8,10-19,13-30,18c-1.881,1.128-2.849,3.453-4.5,5.217l59.683,59.683 c7.121,1.049,14.404,1.599,21.817,1.599c82.014,0,148.5-66.486,148.5-148.5C297,138.221,295.955,128.186,293.966,118.495z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6AAC4B"
    },
    d: "M199.213,100.673c0.167-0.985,22.258-29.595,2.476-44.243c-13.76-10.189-22.223,3.741-11.501,8.985 C205.327,72.82,199.213,100.673,199.213,100.673z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6AAC4B"
    },
    d: "M197.59,99.052c1.061-0.108,30.681-21.41,48.005,0.462c12.051,15.215-2.531,23.169-8.985,11.501 C227.496,94.54,197.59,99.052,197.59,99.052z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#456957"
    },
    d: "M194.803,103.636c0.522-1.027,32.043-20.288,18.692-49.191c-9.287-20.106-22.46-9.322-14.227,3.255 C210.891,75.457,194.803,103.636,194.803,103.636z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#365645"
    },
    d: "M194.804,103.636c1.155-0.748,24.574-42.899,55.564-26.796c21.558,11.202,9,29.245-4.353,19.028 C227.163,81.442,194.804,103.636,194.804,103.636z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E67E22"
    },
    d: "M203.036,99.681c5.769,5.769,16.054,15.428,8.444,32.836S140.283,218.309,67,235.717 c17.408-73.283,85.792-136.87,103.2-144.48C187.608,83.628,197.267,93.912,203.036,99.681z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D16718"
    },
    d: "M203.036,99.681c-5.769-5.769-15.428-16.053-32.836-8.444c-4.312,1.885-11.754,7.208-20.772,15.259 c-0.996,30.078-1.516,60.156-1.899,90.234c34.761-25.09,59.393-53.789,63.95-64.213C219.09,115.109,208.805,105.45,203.036,99.681 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C14C23"
    },
    d: "M161.757,161.6l8.536,17.073c1.544-1.342,3.054-2.679,4.528-4.009L161.757,161.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C14C23"
    },
    d: "M192.991,156.832c2.411-2.592,4.615-5.076,6.609-7.425l-20.643-20.644L192.991,156.832z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C14C23"
    },
    d: "M159.89,97.813l22.507,22.507l-14.075-28.15C166.045,93.409,163.188,95.311,159.89,97.813z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D75E29"
    },
    d: "M142.557,112.879c-1.466,1.412-2.957,2.881-4.473,4.408l13.353,13.353L142.557,112.879z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D75E29"
    },
    d: "M144.338,199.003c2.673-1.878,5.289-3.779,7.845-5.696l-21.386-21.386L144.338,199.003z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D75E29"
    },
    d: "M118.495,138.979l22.622,22.622l-15.491-30.982C123.26,133.3,120.878,136.086,118.495,138.979z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D75E29"
    },
    d: "M100.813,162.576l19.664,19.664l-13.922-27.843C104.617,157.064,102.7,159.792,100.813,162.576z"
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCarrot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/carrot.63df5272.svg";
export { ForwardRef as ReactComponent };